import { isDate, parse, parseISO } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";

export const dateFormat = 'MM/dd/yyyy';
export const timeFormat = 'hh:mmaaa';
export const dateTimeFormat = `${dateFormat} 'at' ${timeFormat}`;

export function isValidDate(date) {
    // no date
    if(!date) {
        return false;
    }

    // invalid date (these should be handled in the api)
    // todo: handle this in the api
    if((""+date).indexOf("0000") !== -1) {
        return false;
    }

    try {
        const parsedTime = isDate(date) ? date : parseISO(date);
        return typeof parsedTime === 'object';// && isDate(parsedTime);
    } catch(e) {
        //
    }

    return false;
}

export function ensureDateObject(date) {
    // no date
    if(!date) {
        return null;
    }

    // invalid date (these should be handled in the api)
    if((""+date).indexOf("0000") !== -1) {
        return null;
    }

    const parsedTime = isDate(date) ? date : parseISO(date);
    return parsedTime;
}

export function formatDate(date, withTime = false, withTimezone = true) {
    if(!date) {
        return null;
    }

    // invalid date (these should be handled in the api)
    if((""+date).indexOf("0000-") !== -1) {
        return null;
    }

    const parsedTime:Date = isDate(date) ? date : parseISO(date);

    //if h:m:s is 0, it probably means we specified our own date, and timezone should be ignored
    if(
        parsedTime.getHours() == 0
        && parsedTime.getMinutes() == 0
        && parsedTime.getSeconds() == 0
    ) {
        withTimezone = false;
    }

    if(!withTimezone) {
        return format(parsedTime, withTime ? dateTimeFormat : dateFormat);
    }

    const formatInTimeZone = (date, fmt, tz) => format(
        utcToZonedTime(date, tz),
        fmt,
        { timeZone: tz }
    );

    return formatInTimeZone(parsedTime, withTime ? dateTimeFormat : dateFormat, "UTC");
}

export function formatAbsoluteDate(date, withTime = false) {
    return formatDate(date, withTime, false);
}

export function formatDateForDatabase(date) {
    return format(date, 'yyyy-MM-dd');
}


export function formatIso(date) { // todo rename this method
    // console.log(date);
    try {
        return format(isDate(date) ? date : parseISO(date), 'yyyy-MM-dd');
    } catch(e) {
        return date;
    }
}

export function dateFromTime(time) {
    if(!time) {
        return null;
    };

    return parse(time, "HH:mm:ss", new Date());
}

export function formatTime(time/*, withTimezone = true*/) {
    if(!time) {
        return null;
    }

    const parsedTime = isDate(time) ? time : dateFromTime(time);

    if(!isValidDate(parsedTime)) {
        console.log(time);
        return null;
    }

    return format(parsedTime, timeFormat);

    /*
    if(!withTimezone) {
        return format(parsedTime, withTime ? dateTimeFormat : dateFormat);
    }

    const formatInTimeZone = (date, fmt, tz) => format(
        utcToZonedTime(date, tz),
        fmt,
        { timeZone: tz }
    );

    return formatInTimeZone(parsedTime, withTime ? dateTimeFormat : dateFormat, "UTC");
    */
}

export function formatTimeForDatabase(date) {
    return format(date, 'HH:mm:ss');
}

export function formatSeconds(seconds) {
    let date = new Date(0);
    date.setSeconds(seconds);
    let timeString = date.toISOString().substring(11, 19);
    // if()
    return timeString.replace(/^00:/, '');
}
